import { Box, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import Meetings from "../components/Meetings/Meetings";
import { GlobalContext } from "../context/GlobalContext";
import InteractionIcon from "../assets/meeting/interaction-icon.svg";
import RightArrowIcon from "../assets/common/right-arrow-icon.svg";
import "../styles/interactions.css";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";
import AppNotification from "../components/Common/AppNotification";
import TaskNotifications from "../components/ActionItems/TaskNotifications";
import useGlobalContext from "../context/useGlobalContext";
import { useNotificationCount } from "../hooks/useNotificationCount";
import ClientAsk7G from "../components/ClientOverview/ClientAsk7G";

interface DateRangeValue {
  preset: string;
  startDate: string;
  endDate: string;
}

const MeetingsPage = () => {
  const { accountDetails } = useContext(GlobalContext);
  const [interactionDateRange, setInteractionDateRange] = useState<DateRangeValue>({ preset: "currentWeek", startDate: "", endDate: "" });
  const location = useLocation();
  const pathParts = location.pathname.split("/"); 
  const lastPart = pathParts[pathParts.length - 1];
  const { featureMap } = useGlobalContext();
  const isNotificationsEnabled = featureMap?.in_app_notifications === true;
  const Ask7GEnabled = featureMap?.business_ask7g === true;
  const [isAsk7GExpanded, setIsAsk7GExpanded] = useState(false);

  useEffect(() => {
    setIsAsk7GExpanded(false);
  }, [location.pathname, location.search]);

  const interactionLabels: Record<string, string> = {
    my: "My Interactions",
    team: "Team Interactions",
    "shared-with-me": "Shared With Me",
    "shared-by-me": "Shared By Me",
  };

  const userProfileOrgId = accountDetails?.profileOrgId ?? "";
  const userNotification = useNotificationCount(userProfileOrgId, isNotificationsEnabled);

  return (
    <Box
      id="meetingsParent"
      className="flex flex-col justify-start items-start gap-6 m-2"
      style={{ width: "auto" }}
    >
      <div className="interaction-breadcrumbs flex flex-row items-center w-full mt-2">
      <div className="flex flex-row justify-start items-center gap-2">
        <Box
          component={isAsk7GExpanded ? "button" : "div"}
          type={isAsk7GExpanded ? "button" : undefined}
          className={`flex flex-row justify-start items-center gap-2 ask7g-home-breadcrumb ${
            isAsk7GExpanded ? "ask7g-home-breadcrumb--expanded" : "ask7g-home-breadcrumb--collapsed"
          }`}
          onClick={isAsk7GExpanded ? () => setIsAsk7GExpanded(false) : undefined}
        >
        <img src={InteractionIcon} alt="" /> <h2>Interactions</h2>
        </Box>
      {interactionLabels[lastPart] && !isAsk7GExpanded &&(
        <>
          <img src={RightArrowIcon} alt="" style={{marginTop: "3px"}}/>
          <h1 className="interactions-title">
            {interactionLabels[lastPart]}
            <span className="interactions-date-range">
              {interactionDateRange?.startDate && interactionDateRange?.endDate && (
                <> ({format(new Date(interactionDateRange?.startDate), "MMM dd yyyy")} - {format(new Date(interactionDateRange?.endDate), "MMM dd yyyy")})</>
              )}
            </span>
          </h1>
        </>
      )}
      {Ask7GEnabled && isAsk7GExpanded && (
        <>
          <img src={RightArrowIcon} alt="" style={{marginTop: "3px"}} />
          <Typography className="breadCrumbs-text ask7g-current-breadcrumb" sx={{fontSize: "16px"}}>
            Ask 7G
          </Typography>
        </>
      )}
      </div>
      <div className="ml-auto flex flex-row items-center gap-3">
        {isNotificationsEnabled && (
          <AppNotification
          notificationCount= {userNotification.notificationCount}
          notificationApiRefetch = {userNotification.getNotificationCountRefetch}
          contentComponent={<TaskNotifications userNotification={userNotification}/>}
          />
        )}
        {Ask7GEnabled && (
          <ClientAsk7G
            view="icon"
            isExpanded={isAsk7GExpanded}
            onToggleExpand={setIsAsk7GExpanded}
          />
        )}
      </div>
      </div>
      {Ask7GEnabled && (
        <Box sx={{ width: "100%", display: isAsk7GExpanded ? "block" : "none" }}>
          <ClientAsk7G
            view="full"
            isExpanded={isAsk7GExpanded}
            onToggleExpand={setIsAsk7GExpanded}
          />
        </Box>
      )}
      <Box sx={{ display: isAsk7GExpanded ? "none" : "block", width: "100%" }}>
        <Meetings setInteractionDateRange = {setInteractionDateRange} />
      </Box>
    </Box>
  );
};

export default MeetingsPage;
